import React, { useEffect, useRef } from 'react';

import { getApplicableL2CompanyModules } from 'Deer/components/navigation/secondary/Company/CompanyModules';
import { MyCompanyDisciplinaryActionsSettingsIntent } from 'Deer/intent/DisciplinaryActions/MyCompanyDisciplinaryActionsSettingsIntent';
import { DisciplinaryActionIntentDropdown } from 'Deer/intent/DisciplinaryActions/components/DisciplinaryActionsIntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { setSelectedView } from 'reducers/viewsSlice';

const COMPANY_COHORT = { id: -1, name: 'My Company', type: 'ALL_EMPLOYEE' };

const MyCompanyDisciplinaryActionsSettings = () => {
  const dispatch = useDispatch();
  const { moduleName } = useOrganisationSettings();

  const applicableL2CompanyModules = getApplicableL2CompanyModules(moduleName) ?? [];

  const gridRef = useRef();

  useEffect(() => {
    dispatch(setSelectedView(COMPANY_COHORT));

    return () => {
      dispatch(setSelectedView({}));
    };
  }, [dispatch]);

  return (
    <Layout
      Filters={
        <DisciplinaryActionIntentDropdown
          gridRef={gridRef}
          showKebabMenu={false}
          breadcrumbs={{
            items: [
              {
                label: 'Company',
                to: applicableL2CompanyModules[0]?.value,
              },
            ],
            page: {
              label: 'Disciplinary Actions',
              to: '',
            },
          }}
        />
      }
    >
      <MyCompanyDisciplinaryActionsSettingsIntent />
    </Layout>
  );
};

export { MyCompanyDisciplinaryActionsSettings };
